"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var _kernel_container_1 = __importDefault(require("../../../container"));
function getMediafileListenCount(history) {
    var e_1, _a;
    var collect = {};
    try {
        for (var history_1 = __values(history), history_1_1 = history_1.next(); !history_1_1.done; history_1_1 = history_1.next()) {
            var item = history_1_1.value;
            if (!collect[item.mediafileId]) {
                collect[item.mediafileId] = 0;
            }
            collect[item.mediafileId]++;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (history_1_1 && !history_1_1.done && (_a = history_1.return)) _a.call(history_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return collect;
}
function getLastRotations(history) {
    var _a;
    var items = [];
    for (var i = history.length - 1; i >= 0; i--) {
        var item = history[i];
        items.push({
            id: item.rotationId,
            mediafileId: item.mediafileId,
            playtime: (0, moment_timezone_1.default)(item.playStartedAt),
            adcompanyId: (_a = item.adcampaignId) !== null && _a !== void 0 ? _a : undefined,
            mediafileType: item.type,
            startNextMark: item.startNext,
            blocksPattern: item.blocksPattern,
            blockIndex: item.blockIndex,
            endTime: item.endTime ? (0, moment_timezone_1.default)(item.endTime) : undefined,
        });
    }
    return items;
}
function generateRotations(settings, mediafiles, availableMediafileIds, generationType) {
    return __awaiter(this, void 0, void 0, function () {
        var logger, start, generation, mediafileListenCount, lastRotations, generationSettings, generatedRotations, playlistItems, correctedPlaylistItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/generateRotations");
                    start = Date.now();
                    generation = _kernel_container_1.default.get("GENERATION");
                    mediafileListenCount = getMediafileListenCount(settings.history);
                    lastRotations = getLastRotations(settings.history);
                    generationSettings = __assign(__assign({}, settings), { onetooneSeparate: 100, startTime: settings.startTime, rotatedMediafiles: mediafileListenCount, lastRotations: lastRotations, availableMediafileIds: availableMediafileIds, generationType: generationType });
                    return [4, generation.generateRotations(generationSettings)];
                case 1:
                    generatedRotations = _a.sent();
                    playlistItems = generatedRotations.map(function (rotation) {
                        var _a;
                        var mediafile = mediafiles[rotation.mediafileId];
                        var meta = mediafile.meta;
                        return {
                            rotationId: 0,
                            mediafileId: mediafile.id,
                            type: mediafile.type,
                            cueIn: meta.cueIn,
                            cueOut: meta.cueOut,
                            startNext: meta.startNext,
                            fadeIn: meta.fadeIn,
                            fadeOut: meta.fadeOut,
                            streamId: rotation.adcompanyId ? undefined : settings.stream.id,
                            adcampaign: rotation.adcompanyId ? { id: rotation.adcompanyId } : undefined,
                            adcampaignId: rotation.adcompanyId,
                            playtime: Date.parse(rotation.playtime.toISOString()),
                            blockIndex: rotation.blockIndex,
                            blocksPattern: rotation.blocksPattern,
                            blockId: rotation.blockId,
                            tagId: rotation.tagId,
                            endTime: (_a = rotation.endTime) === null || _a === void 0 ? void 0 : _a.toISOString(),
                        };
                    });
                    correctedPlaylistItems = generation.correctMarks(playlistItems);
                    logger.warn("Generation took", { seconds: (Date.now() - start) / 1000 });
                    return [2, correctedPlaylistItems];
            }
        });
    });
}
exports.default = {
    generateRotations: generateRotations,
};
//# sourceMappingURL=index.js.map